export enum ChangePeriod {
  // "1H" = "1H",
  "24H" = "24H",
  "7D" = "7D",
  "30D" = "30D",
}

export const changePeriodToDisplayName: Record<ChangePeriod, string> = {
  [ChangePeriod["1H"]]: "1h",
  [ChangePeriod["24H"]]: "24h",
  [ChangePeriod["7D"]]: "7d",
  [ChangePeriod["30D"]]: "30d",
};
